import { fork } from "redux-saga/effects"

import { execDAuthInitial } from "sagas/DAuth"
import { handleGetAgreementCards } from "sagas/GetAgreementCards"
import { handleGetThirdPartyInfo } from "sagas/GetThirdPartyInfo"
import { handlePutThirdPartyInfo } from "sagas/PutThirdPartyInfo"
import { handleGetNoticeAgreement } from "sagas/GetNoticeAgreement"
import { handlePutNoticeAgreement } from "sagas/PutNoticeAgreement"
import { handleGetLocaleAgreement } from "sagas/GetLocaleAgreement"
import { handlePutLocaleAgreements } from "sagas/PutLocaleAgreements"
import { handleGetUserAgreementsStatus } from "sagas/GetUserAgreementsStatus"
import { handlePutUserAgreementsStatus } from "sagas/PutUserAgreementsStatus"

export default function* rootSaga() {
  yield fork(execDAuthInitial)
  yield fork(handleGetAgreementCards)
  yield fork(handleGetThirdPartyInfo)
  yield fork(handlePutThirdPartyInfo)
  yield fork(handleGetNoticeAgreement)
  yield fork(handlePutNoticeAgreement)
  yield fork(handleGetLocaleAgreement)
  yield fork(handlePutLocaleAgreements)
  yield fork(handleGetUserAgreementsStatus)
  yield fork(handlePutUserAgreementsStatus)
}
